<template>
  <!-- 组合框 -->
  <div ref="loading-box" class="Others10Charts" :class="getStyle('title')">
    <!-- 锁 -->
    <div @click="OpenCarouselClick" v-show="showOpenCarou" class="openImg">
      <img v-show="!showCarousel" class="carrouse" src="../../../../public/img/carouselimg/carouse1.png" />
      <img v-show="showCarousel" class="carrouse" src="../../../../public/img/carouselimg/carouse2.png" />
    </div>
    <!-- 走马灯  style="width: 100%" -->
    <div class="carousel">
      <el-carousel :interval="5000" :autoplay="autoplay" :height="CarouselHeight + 'px'" arrow="never">
        <!-- 走马灯里的每个item  ComboBoxCharts 子所有组件图表值-->
        <el-carousel-item
          v-for="item in ComboBoxCharts"
          :key="item.id"
          :Configuration="item"
          :ProjectInfo="ProjectInfo"
          @mousedown="chartClickMousedown(item, $event)"
          @contextmenu="handleContextMenu($event)"
          :active="$store.state.CurrentConfigration.id === item.id"
          :height="CarouselHeight + 'px'"
        >
          <!-- 子组件 标题名称 -->
          <component
            :Configuration="item"
            :ProjectInfo="ProjectInfo"
            ref="Project-item"
            :is="item.propertyData.borderConfig.value.borderComponentName"
          >
            <!-- 子组件 图表 -->
            <component
              :is="item.componentName"
              :style="getMenuStyle()"
              :Configuration="item"
              :ProjectInfo="ProjectInfo"
            ></component>
          </component>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div @click="combileClick">
      <ComBined></ComBined>
    </div>
  </div>
</template>
<script>
// 初始化 组件引入
let _AutoImportComponengts = () => {
  const path = require('path');
  const _Componengts = {};
  const files = require.context('@/components/backgrounds', true, /\.vue$/);
  files.keys().forEach(key => {
    const name = path.basename(key, '.vue');

    _Componengts[name] = files(key).default || files(key);
  });
  const files2 = require.context('@/components/charts', true, /\.vue$/);
  files2.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files2(key).default || files2(key);
  });
  const files3 = require.context('@/components/styles', true, /\.vue$/);
  files3.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files3(key).default || files3(key);
  });
  const files4 = require.context('@/components/borders', true, /\.vue$/);
  files4.keys().forEach(key => {
    const name = path.basename(key, '.vue');
    _Componengts[name] = files4(key).default || files4(key);
  });
  for (let key in _Componengts) {
    if (key.endsWith('Background')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _BackgroundsList.push(Configuration);
      }
    }
    if (key.endsWith('Charts')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _ChartsList.push(Configuration);
      }
    }
    if (key.endsWith('Style')) {
      let Configuration = _Componengts[key]['Configuration'];
      if (Configuration) {
        _StylesList.push(Configuration);
      }
    }
  }
  return _Componengts;
};
const _ChartsList = [];
const _StylesList = [];
const _BackgroundsList = [];
const _AutoComponengts = _AutoImportComponengts();
// console.log('初始化 组件导入：', _AutoComponengts);

import VShape from '@/views/commonviews/VShape.vue';
import ComBined from '@/views/commonviews/ComBined.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'Others10Charts',
  components: {
    VShape,
    ComBined,
    ..._AutoComponengts,
  },
  props: {
    ComboBoxCharts: Object,
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxId: String,
    active: Boolean,
  },
  created() {
    this.set_BackgroundsList(_BackgroundsList);
    this.set_ChartsList(_ChartsList);
    this.set_StylesList(_StylesList);
    this.$store.commit('setBackgroundDefault', JSON.parse(JSON.stringify(this.ProjectInfo.Background)));
    this.registerDebounceAndThrottle();
    this.debounce_applyConfigPosSize = this.$_.debounce(this.applyConfigPosSize, 300);
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
  },
  data() {
    return {
      Style: {},
      isMoving: false,
      showCarousel: false,
      autoplay: true,
      showOpenCarou: false,
      ComboStyle: {},
      menuStyle: {
        height: 85,
        width: 700,
      },
      CarouselHeight: '',
    };
  },
  watch: {
    ComboBoxCharts: {
      deep: true,
      handler: function(val) {
        this.wacthDataBoxCharts();
        this.getCoponentSizeStyle();
      },
    },
    Configuration: {
      deep: true,
      handler: function(newVal) {
        console.log(newVal, 'newVal newVal Configuration');
        this.CarouselHeight = newVal.style.height;
        this.ComboStyle = newVal.style;
        this.getMenuStyle();
        this.debounce_applyConfigPosSize();
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
    ComboStyle: {
      deep: true,
      handler: function(v) {},
    },
  },
  mounted() {
    this.getCoponentSizeStyle();
    this.wacthDataBoxCharts();
    this.setComboBoxChartsList(this.ComboBoxCharts);
    this.$nextTick(() => {
      this.getMenuStyle();
      // this.CarouselHeight;
      console.log(this.CarouselHeight, 'this.CarouselHeight this.CarouselHeight');
    });
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  unmounted() {
    this.debounce_applyConfigPosSize.cancel();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    ...mapMutations(['set_BackgroundsList', 'del_CurrentConfigration', 'set_ChartsList', 'set_StylesList']),
    setComboBoxChartsList(val) {
      val.forEach(item => {
        let boxchar = { val: item, cid: this.ComboBoxId };
        this.$store.commit('set_CurrentConfigration', boxchar);
      });
    },
    // 判断 ComboBoxCharts.length > 1 锁现
    wacthDataBoxCharts() {
      if (this.ComboBoxCharts.length > 1) {
        this.showOpenCarou = true;
      } else if (this.ComboBoxCharts.length <= 1) {
        this.showOpenCarou = false;
      }
    },
    // 开启自动轮播按钮
    OpenCarouselClick() {
      if ((this.showCarousel = !this.showCarousel)) {
        this.autoplay = false;
      } else {
        this.autoplay = true;
      }
    },
    // 提交 子组件 数据 提交 到vuex
    chartClickMousedown(item, e) {
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
      let moueChet = { val: item, cid: this.ComboBoxId };
      this.$store.commit('set_CurrentConfigration', moueChet);
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
    // getAssemblyStyle() {
    //   let propMenuStyle = this.Configuration.propertyData.posSize;
    //   let proxyStyle = this.Configuration.style;
    //   console.log(propMenuStyle, proxyStyle, 'getAssemblyStyle getAssemblyStyle');
    //   let boxcharts = JSON.parse(JSON.stringify(this.ComboBoxCharts));
    //   console.log(boxcharts, 'getAssemblyStyle boxcharts boxcharts');

    //   // this.$store.commit('update_PropertyData', {
    //   //   key: this.propertyDataKey,
    //   //   value: {
    //   //     chartColor: this.chartColor,
    //   //     chartBackgroundColor: this.chartBackgroundColor,
    //   //   },
    //   // });
    // },
    // w，h，t，l 计算
    getCoponentSizeStyle() {
      let { width, height, left, top } = this.Configuration.style;
      this.Style.width = width + 'px';
      this.Style.height = height + 'px';
      this.Style.top = top + 'px';
      this.Style.left = left + 'px';
      if (this.Configuration.propertyData.chartsOpicity) {
        this.Style.opacity = this.Configuration.propertyData.chartsOpicity.value;
      }
      if (this.Configuration.propertyData.chartsColor) {
        this.Style.backgroundColor = this.Configuration.propertyData.chartsColor.value.chartBackgroundColor;
      }
    },
    applyConfigPosSize() {
      if (
        this.Configuration.Charts &&
        this.Configuration.Charts.propertyData &&
        this.Configuration.Charts.propertyData.posSize &&
        this.isMoving === false &&
        this.$store.state.isEdingChartsPosSize
      ) {
        if (this.$store.state.CurrentConfigration.style) {
          this.$store.commit('update_CurrentConfigration', {
            style: { ...this.Configuration.Charts.propertyData.posSize.value },
          });
        }
      }
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          style = {};
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        case 'V13Style':
          style = {};
          if (bool) style['V13StyleTitle'] = true;
          style['V13Style'] = true;
          break;
        case 'V14Style':
          style = {};
          if (bool) style['V14StyleTitle'] = true;
          style['V14Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    getMenuStyle() {
      let proxyStyle = this.Configuration.style;
      this.CarouselHeight = this.Configuration.style.height;
      this.$store.commit('update_PropertyData', {
        key: 'posSize',
        value: proxyStyle,
      });
      this.$store.commit('update_PropertyData', {
        key: 'style',
        value: proxyStyle,
      });
      return {
        height: proxyStyle.height - this.$h_Ratio(30, this.$store) + 'px',
      };
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
    },
    // 删除 按钮
    handleContextMenu(e) {
      console.log(e, 'stopPropagation');
      e.stopPropagation();
      e.returnValue = false;
      let top = e.clientY;
      let left = e.clientX;
      this.$store.commit('set_ComBined', {
        isOpen: true,
        position: {
          left,
          top,
        },
      });
      const up = () => {
        document.removeEventListener('mousedown', up);
      };
      document.addEventListener('mousedown', up);
    },
    // 监听 组合 鼠标点击 移除右键菜单
    combileClick() {
      this.$store.commit('set_ComBined', {
        isOpen: false,
      });
    },
  },
  Configuration: {
    componentTitle: '组合组件',
    componentName: 'Others10Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others10Charts.png',
    id: '',
    style: {
      width: 360,
      height: 220,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    Charts: [],
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
li {
  list-style-type: none;
}
.Others10Charts {
  padding: 4px;
  ::v-deep.el-carousel {
    position: revert;
  }
  .carousel {
    height: auto;
    // max-height: 260px;
    // overflow-y: scroll;
    background-size: 100% 100%;
  }
  .openImg {
    z-index: 999;
    position: absolute;
    right: 3%;
    top: 0;
    .carrouse {
      width: 20px;
      display: inline-block;
    }
  }
  .el-carousel__button {
    display: block;
    opacity: 0.48;
    width: 8px;
    height: 8px;
    border-radius: 10px;
    background-color: #04358b;
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
  }
  .el-carousel__container {
    // height: 400px;  轮播图高度固定值
    width: 100%;
  }
  .is-active .el-carousel__button {
    background-color: #01ffdc;
  }

  .banner-circle {
    width: 100%;
    height: 15%;
  }
  .banner-circle ul {
    margin: 0 50px;
    height: 100%;
    text-align: right;
  }
  .banner-circle ul li {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin: 0 6px;
    border-radius: 6px;
    background-color: azure;
    cursor: pointer;
  }
  .active {
    background-color: #eb4b4b !important;
  }
}
.workbench-body {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
.screen-wrapper-outer {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  background-color: #909399;
  // background-image: url('../../../assets/img/workbench_bg.png');
  &::-webkit-scrollbar {
    z-index: 0 !important;
    width: 2px;
    height: 2px;
    background-color: #141517;
  }
  &::-webkit-scrollbar-corner {
    z-index: 0;
    background-color: #141517;
  }
  &::-webkit-scrollbar-thumb {
    width: 2px;
    height: 2px;
    z-index: 0 !important;
    background-color: #909399;
  }
  .screen-wrapper {
    position: absolute;
    top: 40px;
    left: 40px;

    padding-bottom: 50px;
    padding-right: 50px;

    .screen {
      // width: 400px;
      // height: 200px;
      // background-color: #464c6b;
      box-shadow: rgb(0 0 0 / 90%) 0 0 30px 0;
    }
  }
}
.title {
  font-size: 14px;
}
// .blueboder {
//   border: 1px solid #008cff;
// }
.v2-style {
  z-index: 99;
  // position: absolute;
  // top: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  // transform: scale(0.3);
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.39) 45%, transparent 100%);
  // background-color: rgb(14, 33, 73);
  .header-left {
    max-width: 460px;
    width: 30%;
    height: 100%;
    position: relative;
    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;
      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }
}
.V12Style {
  .openImg {
    height: 10%;
    min-height: 32px;
    z-index: 999;
    position: absolute;
    right: 3%;
    top: 6%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    .carrouse {
      width: 20px;
      display: inline-block;
    }
  }
  .el-carousel__indicators--horizontal {
    top: 5%;
    left: 87%;
    height: 10%;
    position: absolute;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-carousel__button {
    background-color: #5e7fba;
  }
  .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 7px 2px;
  }
}
</style>
